import hoistStatics from 'hoist-non-react-statics';
import Router, { useRouter } from 'next/router';
import React from 'react';

import { To } from '../types';
import {
  convertLocationToHref,
  convertRouterObjectToLocation,
  warnUnimplemented,
} from '../utils';

function withRouter(WrappedComponent: any): React.FC {
  const Component = (props: any) => {
    const router = useRouter();

    const push = (route: To) => {
      const href = convertLocationToHref(route);
      Router.push(href);
    };

    const location = convertRouterObjectToLocation(router);

    const history = {
      length: 0, // not supported
      action: 'PUSH', // not supported
      location,
      push,
      replace: Router.replace,
      goBack: Router.back,
      goForward: () => warnUnimplemented('history.goForward'),
      go: () => warnUnimplemented('history.go'),
      block: () => warnUnimplemented('history.block'),
    };

    const { pathname, query, route } = router;

    const match = {
      params: query,
      isExact: false,
      path: route,
      url: pathname,
    };

    return (
      <WrappedComponent
        {...props}
        location={location}
        history={history}
        router={history}
        match={match}
        params={query}
        queries={query}
      />
    );
  };

  return hoistStatics(Component, WrappedComponent);
}

export default withRouter;
